export const GROUP_NOT_VOLATILE_DATA_POOLING_INTERVAL = 600000; // 10 min
